import { ChangeDetectorRef, EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { ControlValueAccessor, NgControl, } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { identifier } from '@uipath/angular/utilities';
import { Subject } from 'rxjs';
var UiToggleSwitchComponent = /** @class */ (function () {
    function UiToggleSwitchComponent(_cd) {
        this._cd = _cd;
        this.defaultValue = true;
        this.labelText = 'Value';
        this.onString = 'True';
        this.offString = 'False';
        this.disabled = false;
        this.currentValue = null;
        this.shouldLabelFloat = false;
        this.stateChanges = new Subject();
        this.ngControl = null;
        this.focused = false;
        this.shouldPlaceholderFloat = false;
        this.errorState = false;
        this.describedBy = '';
        this.optionChange = new EventEmitter();
        this._required = false;
        this._onChange = function (_value) { };
        this._onTouch = function () { };
        this._randomName = identifier();
        this.id = 'toggle-switch-' + this._randomName;
    }
    UiToggleSwitchComponent.prototype.ngOnInit = function () {
        this.currentValue = this.defaultValue;
    };
    UiToggleSwitchComponent.prototype.ngOnDestroy = function () {
        this.stateChanges.complete();
    };
    Object.defineProperty(UiToggleSwitchComponent.prototype, "value", {
        get: function () {
            return this.currentValue;
        },
        set: function (state) {
            this.currentValue = state;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiToggleSwitchComponent.prototype, "placeholder", {
        get: function () {
            return this.labelText;
        },
        set: function (plh) {
            this.labelText = plh;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiToggleSwitchComponent.prototype, "empty", {
        get: function () {
            return this.currentValue == null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiToggleSwitchComponent.prototype, "required", {
        get: function () {
            return this._required;
        },
        set: function (req) {
            this._required = req;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    UiToggleSwitchComponent.prototype.writeValue = function (value) {
        this.currentValue = value;
        this._cd.markForCheck();
        this.stateChanges.next();
    };
    UiToggleSwitchComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    UiToggleSwitchComponent.prototype.registerOnTouched = function (fn) {
        this._onTouch = fn;
    };
    UiToggleSwitchComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this._cd.detectChanges();
    };
    UiToggleSwitchComponent.prototype.setDescribedByIds = function (ids) {
        this.describedBy = ids.join(' ');
    };
    UiToggleSwitchComponent.prototype.onContainerClick = function (_event) { };
    UiToggleSwitchComponent.prototype.onChange = function (state) {
        this.writeValue(state.value);
        this._onChange(state.value);
        this.optionChange.emit(state.value);
    };
    UiToggleSwitchComponent.prototype.onClick = function () {
        this._onTouch();
    };
    return UiToggleSwitchComponent;
}());
export { UiToggleSwitchComponent };
